import { FiltroOtros } from '../types/Types';

// eslint-disable-next-line import/prefer-default-export
export class FiltersConstants {
  // IS_SOPORTE_POSTAL_VISIBLE --> PARA mostrar filtros de soporte-postal EN PRE-PRODUCCION Y EN DESARROLLO, en PRODUCCION siempre va a false.
  // eslint-disable-next-line no-unneeded-ternary
  static IS_SOPORTE_POSTAL_VISIBLE = process.env.NODE_ENV !== 'production';

  // descomentar para ocultar los filtros de soporte postal en todos los entornos
  // static IS_SOPORTE_POSTAL_VISIBLE = false;

  static ATRIBUTO_DATA_ID = 'data-id';

  static ATRIBUTO_DATA_TIPO_LISTA = 'data-tipolista';

  static SELECTOR_CUPONES_VISIBLES = 'show';

  static SELECTOR_CUPONES_OCULTOS = 'hide';

  static PRODUCTOS_TOTAL_ESTRUCTURA = 'TOTAL ESTRUCTURA';

  static NUM_CUPONES_MOSTRADOS_AL_INICIO = 9 as number;

  static NUM_CUPONES_POR_LINEA = 3 as number;

  static NUM_CUPONES_BTN_VER_MAS = 6 as number;

  static FILTROS_OTROS_PLAN_ADHESION: FiltroOtros[] = [
    { codigo: '0', denominacion: 'Sin informar', enseya: '', recibido: false },
    {
      codigo: '1',
      denominacion: 'Plan familias',
      enseya: 'E',
      recibido: false,
    },
    { codigo: '2', denominacion: 'Ekilibria', enseya: 'E', recibido: false },
    {
      codigo: '3',
      denominacion: 'Familias Numerosas',
      enseya: 'C',
      recibido: false,
    },
    { codigo: '4', denominacion: 'Seat', enseya: 'C', recibido: false },
    {
      codigo: '5',
      denominacion: 'Caprabo Ayuda 1',
      enseya: 'C',
      recibido: false,
    },
    { codigo: '6', denominacion: 'Ampans', enseya: 'C', recibido: false },
    { codigo: '7', denominacion: 'Pensa', enseya: 'C', recibido: false },
  ];

  static FILTROS_OTROS_SOPORTE_POSTAL: FiltroOtros[] = [
    {
      codigo: '0',
      denominacion: 'Sin carta/postal',
      enseya: '',
      recibido: false,
    },
    { codigo: '1', denominacion: 'ReporClub', enseya: 'E', recibido: false },
    { codigo: '2', denominacion: 'Salud', enseya: 'E', recibido: false },
    { codigo: '3', denominacion: 'Mascotas', enseya: 'E', recibido: false },
    { codigo: '4', denominacion: 'Supermazine', enseya: 'C', recibido: false },
    {
      codigo: '5',
      denominacion: 'Carta genérica',
      enseya: '',
      recibido: false,
    },
  ];
}
